// extracted by mini-css-extract-plugin
export default {"task":"Task_task__IqAnd","label":"Task_label__TetAU","editorWrapper":"Task_editorWrapper__vvlpu"};